/**
 * UserSidebarSkeleton - Skeleton для UserSidebar
 *
 * CANON 5.3/5.4 Compliance:
 * - Skeleton shape MUST match final content shape (no CLS)
 * - Matches exact structure of UserSidebar: logo, nav groups, footer
 */
import { cn } from "@/lib/utils";
import { semanticTokens } from "@packages/config/theme";
import { SkeletonLine } from "@/ui/skeleton";

interface UserSidebarSkeletonProps {
  className?: string;
}

export function UserSidebarSkeleton({ className }: UserSidebarSkeletonProps) {
  return (
    <aside
      className={cn(
        "w-64 bg-sidebar flex flex-col h-screen",
        className
      )}
      aria-label="Loading navigation"
      role="status"
    >
      {/* Logo area */}
      <div className="p-4">
        <div className={cn("h-8 w-32", semanticTokens.bg.muted, semanticTokens.radius.md, "animate-pulse")} />
      </div>

      {/* Navigation Groups */}
      <div className="flex-1 p-4 space-y-6">
        {/* Finance Group */}
        <div className="space-y-3">
          <div className={cn("h-3 w-16", semanticTokens.bg.muted, semanticTokens.radius.sm, "animate-pulse")} />
          <div className="space-y-1">
            {[1, 2, 3].map((i) => (
              <div key={i} className="flex items-center gap-3 p-2 rounded-md">
                <div className={cn("h-5 w-5 rounded", semanticTokens.bg.muted, "animate-pulse")} />
                <SkeletonLine width="70%" height="1rem" animate />
              </div>
            ))}
          </div>
        </div>

        {/* Account Group */}
        <div className="space-y-3">
          <div className={cn("h-3 w-16", semanticTokens.bg.muted, semanticTokens.radius.sm, "animate-pulse")} />
          <div className="space-y-1">
            {[1].map((i) => (
              <div key={i} className="flex items-center gap-3 p-2 rounded-md">
                <div className={cn("h-5 w-5 rounded", semanticTokens.bg.muted, "animate-pulse")} />
                <SkeletonLine width="60%" height="1rem" animate />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="p-4">
        <div className="flex items-center gap-3 p-2">
          <div className={cn("h-8 w-8 rounded-full", semanticTokens.bg.muted, "animate-pulse")} />
          <div className="space-y-1 flex-1">
            <SkeletonLine width="80%" height="0.875rem" animate />
            <SkeletonLine width="60%" height="0.75rem" animate />
          </div>
        </div>
      </div>
    </aside>
  );
}
